export const APP_ROUTING: Record<any, string> = {
  LOGIN: '/login',
  LANDING_PAGE: '/landing-page',
  TEACHER_DASHBOARD: '/pages/teacher-dashboard',
  STUDENT_DASHBOARD: '/pages/student-dashboard',
  ADMIN_DASHBOARD: '/pages/admin-dashboard',
  CHAT: '/pages/chat',
  CALENDAR: '/pages/calendar',
  BLOG: '/pages/blog',
  EXAM: '/pages/exam',
  EXAM_QUESTIONS: '/pages/exam-question',
  PROFILE: '/pages/profile',
  BASIC_DETAILS: '/pages/basic',
  EDUCATION_DETAILS: '/pages/edu',
  EXPERIENCE_DETAILS: '/pages/exp',
  ACHIEVEMENTS: '/pages/achi',
  SPECIALIZATION: '/pages/special',
  MATRIX: '/pages/matrix',
  PROFILE_SETTINGS: '/pages/settings',
  QUESTION_BANK: '/pages/questionbank',
  QUESTION_BANK_Add_EDIT: '/pages/questionbank/questionedit',
  get QUESTION_BANK_EDIT() {
    return this['QUESTION_BANK'] + '/edit';
  },
  QUESTION_CATEGORIES: '/pages/categories',
  EXAM_LISTING: '/pages/exam/exam-listing',
  EXAM_APP: '/pages/exam/exam-app',
  EXAM_QUESTION: '/pages/exam/exam-question',
  VIEW_EXAM: '/pages/exam/view-exam',
  EXAM_ANALYSIS: '/pages/exam-analysis',
  QUIZ_ANALYSIS: '/pages/quiz-analysis',
  EXAM_PROCTORING: '/pages/exam-proctoring',
  ASSIGNMENTS: '/pages/assignment',
  QUIZ: '/pages/quiz',
  QUIZ_QUESTION: '/pages/quiz/quiz-app',
  TAKE_QUIZ: '/take-quiz',
  QUIZ_MODE_SELECTION: '/take-quiz/:id/mode',
  QUIZ_FLASHPRO: '/take-quiz/:id/flashpro',
  QUIZ_FLASH: '/take-quiz/:id/flash',
  QUIZ_REVIEW: '/take-quiz/:id/review',
  QUIZ_TIME_CHALLENGED: '/take-quiz/:id/timeChallenged',
  NOTIFICATION: '/pages/noti',
  SUBJECTS: '/pages/subjects',
  SUBJECT_FORM: '/pages/subjects/subject-form',
  ADMIN_COURSE_VIEW: '/pages/admin-course-view',
  STUDENT_MANAGEMENT: '/pages/management/student',
  TEACHER_MANAGEMENT: '/pages/management/teacher',
  STUDENT_DETAILS: '/pages/management/student/student-details',
  TEACHER_DETAILS: '/pages/management/teacher/teacher-details',
  CATEGORIES_FORM: '/pages/category-form',
  EDIT_ASSIGNMENT: '/pages/assignment/editassignment',
  MANAGMENT: '/pages/management',
  QUESTION_EDIT: '/pages/questionedit',
  EXAM_CONFIGURATION: '/pages/exam/configuration-settings',
  NOTFOUNT: '/login',
  ASSIGNMENT_SUBMISSION: '/pages/assignment/assignmentsubmission',
  ASSIGNMENT_REVIEW: '/pages/assignment/assignmentreview',
  ACCESS_DENIED: '/access-denied',
  TAKE_EXAM: '/take-exam',
  EXAM_INSTRUCTIONS: '/exam-instructions',
  AI_SEARCH: '/pages/ai-search',
  EDIT_RESOURCE: '/pages/resource/editResource',
  RESOURCE_LISTING: '/pages/resource',
  NOTEBOOK_CREATION: '/pages/notebook-creation',
  NOTEBOOK_EDITOR: '/pages/notebook-editor',
  LIVE_CLASS: '/pages/live-class',
};
